import React from 'react'

import { NotificationList } from './components/NotificationList/NotificationList'

import { INotification } from 'src/api/notifications/types'
import { BellWithBackgroundIcon } from 'src/components/Icons/BellWithBackground'
import { EmptyState } from 'src/components/EmptyState/EmptyState'

interface Props {
  getMore: () => void
  notifications: INotification[]
  refetchNotifications: () => void
  total: number
}
export const NotificationsData: React.FC<Props> = ({
  getMore,
  notifications,
  refetchNotifications,
  total,
}) =>
  notifications.length ? (
    <NotificationList
      notifications={notifications}
      total={total}
      getMore={getMore}
      refetchNotifications={refetchNotifications}
    />
  ) : (
    <EmptyState
      icon={BellWithBackgroundIcon}
      title="No activity yet"
      body="Your notifications will live here"
    />
  )
